<template>
  <div>
    <slot/>

    <v-data-table :headers="headers" :items="getFiles" must-sort hide-actions item-key="id">
      <template slot="items" slot-scope="file">
        <tr>
          <td>{{ file.item.desc }}</td>
          <td><small>{{ file.item.name }}<br/>{{ file.item.size | filesize }}</small></td>
          <td>{{ fileVisibilityLabel(file.item.visibility) }}</td>
        </tr>
      </template>
      <template slot="no-data">
        (No files)
      </template>
    </v-data-table>

    <div style="padding: 1em 2em 2em; border-top: 1px solid #ddd;" v-if="addFiles">
      <div v-if="showForm">
        <form ref="uploadForm">
          <div class="clearfix">
            <fieldset class="col24">
              <label for="description">Description</label>
              <input type="text" v-model="description" id="description" maxlength="255" required :disabled="uploading" />
            </fieldset>
            <fieldset class="col14">
              <label for="file">File</label>
              <input type="file" id="file" ref="file" required :disabled="uploading" />
            </fieldset>
            <fieldset class="col14">
              <label for="visibility">Visibility</label>
              <select id="visibility" v-model="visibility" :disabled="uploading">
                <option :value="fileVisibility.PUBLIC.value">{{ fileVisibility.PUBLIC.label }}</option>
                <option :value="fileVisibility.LOGGED_IN.value">{{ fileVisibility.LOGGED_IN.label }}</option>
                <option :value="fileVisibility.AUTHORIZED.value">{{ fileVisibility.AUTHORIZED.label }}</option>
              </select>
            </fieldset>
          </div>
          <fieldset>
            <button @click.prevent="showForm = false" :disabled="uploading">Cancel</button>
            <button @click.prevent="doUpload" :disabled="uploading">Upload</button>
            <InlineSpinner v-if="uploading" />
          </fieldset>
        </form>
      </div>
      <div v-else style="text-align: center">
        <v-icon>file_upload</v-icon> <a @click.prevent="showForm = true">Upload a new file</a>
      </div>
    </div>

  </div>
</template>

<script>

  import { mapGetters, mapMutations } from 'vuex'
  import { fileVisibility, fileVisibilityLabel } from '../utils/PfxUtils.js'
  import InlineSpinner from './elements/InlineSpinner.vue'

  export default {
    name: 'CreateListingFileUpload',
    components: {
      InlineSpinner
    },
    props: {
      addFiles: {
        type: Boolean,
        required: false,
        default: true
      }
    },
    data() {
      return {
        fileVisibility,
        fileVisibilityLabel,
        headers: [
          { text: 'Description', align: 'left', sortable: true, value: 'desc' },
          { text: 'Filename / Size', align: 'left', sortable: true, value: 'name' },
          { text: 'Visibility', align: 'left', sortable: true, value: 'visibility' }
        ],
        showForm: false,
        description: '',
        visibility: 'AUTHORIZED',
        uploading: false
      }
    },
    computed: {
      ...mapGetters([
        'getFilesForNewAuction'
      ]),
      getFiles() {
        return this.getFilesForNewAuction
      }
    },
    created() {
      this.resetForm()
    },
    methods: {
      ...mapMutations([
        'addFileForNewAuction'
      ]),

      resetForm() {
        this.description = ''
        this.visibility = 'AUTHORIZED'
        this.showForm = false
      },

      doUpload() {
        // Validate form (force precence of description)
        if (!this.$refs.uploadForm.checkValidity()) {
          this.$refs.uploadForm.reportValidity()
          return
        }

        const file = this.$refs.file.files[0]

        if (!file) {
          console.log('no file, abort')
          return
        }

        let fileData = {
          name: file.name,
          type: file.type,
          size: file.size,
          desc: this.description,
          visibility: this.visibility
        }

        const reader = new FileReader()
        reader.onloadstart = () => {
          this.uploading = true
        }
        reader.onerror = (err) => {
          console.log('reader.onerror', err)
          this.uploading = false
          this.$notify({ type: 'danger', message: 'Unexpected error during file upload. Please retry.' })
        }
        reader.onload = () => {
          fileData.data = reader.result
          this.addFileForNewAuction(fileData) // Do not upload files immediately but store them in store
          console.log('Upload stored [%s][%s][%s][%s][%s][%s]', fileData.name, fileData.type, fileData.size, fileData.desc, fileData.visibility, fileData.data.length)
          this.uploading = false
          this.resetForm()
        }
        reader.readAsDataURL(file)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import 'node_modules/jeet/scss/index';

  .col14 { @include column(1/4); }
  .col24 { @include column(2/4); }

</style>



// WEBPACK FOOTER //
// src/components/CreateListingFileUpload.vue